<script>
    import {APP_PATH, APP_VERSION} from "./lib/constants";
    import Route, {router} from "./lib/Router/Router.svelte";
    import R, {LOADER} from "./lib/requests";
    import app from './stores/app';
    import cart from "./stores/cart";
    import user from "./stores/user";
    import AppHeader from "./components/AppHeader.svelte";
    import Alert from "./components/Alert.svelte";
    import Notifier from './components/Notifier.svelte';
    import PageLoader from "./components/PageLoader.svelte";
    import PopupLoader from "./components/PopupLoader.svelte";
    import AppIcon from "./components/icons/AppIcon.svelte";
    import Dashboard from "./dashboard/Dashboard.svelte";
    import Checkout from "./cart/Checkout.svelte";
    import SignUp from "./signup/SignUp.svelte";
    import VerifyAccount from "./signup/VerifyAccount.svelte";
    import ResetPassword from "./account/ResetPassword.svelte";
    import MyAccount from "./account/MyAccount.svelte";
    import Orders from "./order/Orders.svelte";
    import Documents from "./documents/Documents.svelte";
    import OrderDetails from "./order/OrderDetails.svelte";
    import OrderCompleted from "./order/OrderCompleted.svelte";
    import OrderFailed from "./order/OrderFailed.svelte";
    import Product from "./product/Product.svelte";
    // import A from "./lib/Router/A.svelte";
    import LoginModal from "./account/LoginModal.svelte";
    import SideCart from "./cart/SideCart.svelte";
    import AccountError from "./components/pages/AccountError.svelte";

    let appInitialized = false;
    let showEcommerceLogos = false;

    const appInitialize = () => {
        const onSuccess = result => {
            if (result.user) {
                user.setUser(result.user);
            }
            $user.shop_subscription_years = result.settings.shop_subscription_years;
            $user.document_subscription_years = result.settings.document_subscription_years;

            $app.regions = result.regions;
            $app.shipping = result.shipping;
            $app.product_image_url = result.product_image_url;
            $app.default_vat = result.settings.default_vat;

            // app.setPageMetaTags(result.page);
            // if (result.page) {
            //     $app.page = result.page;
            // }

            // initialize cart products
            cart.setProducts(result.cart);

            if (APP_VERSION !== result.settings.app_version) {
                alert("Η έκδοση της εφαρμογής που χρησιμοποιείται είναι πεπερασμένη!\nΚαθαρίστε την προσωρινή μνήμη του browser σας και ανανεώστε αυτή την σελίδα για να χρησιμοποιήσετε την πιο πρόσφατη έκδοση της εφαρμογής.");
            }

            appInitialized = true;
        }

        const onFailure = err => {
        };

        user.initialize();
        cart.initialize();

        R.handle(R.app.initialize, {
            cart: cart.getProductIds(),
            path: window.location.pathname
        }, onSuccess, onFailure, LOADER.PAGE);
    }

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && $app.escapeEventHandlers.length) {
            $app.escapeEventHandlers[$app.escapeEventHandlers.length - 1]();
        }
    });

    appInitialize();

    $: {
        showEcommerceLogos = ($router.url === '/' || $router.url === '/checkout');
        app.setPageMetaTags($router.url);
    }
</script>


{#if appInitialized}
    <PopupLoader/>
    <AppHeader/>
    <PageLoader/>
    <SideCart/>
    <main class:ecommerce={ showEcommerceLogos }>
        <div class="shop-header">
            <div class="shop-header-body">
                <div class="header-body-left">
                    <img src="/assets/images/pks-logo.png" alt="pkh logo">
                </div>
                <div class="header-body-right">
                    <a href="tel:2105202901" class="contact-info"><span class="icon">
                                <AppIcon icon="phone-solid"/>
                            </span>210 5202 901</a>
                    <a href="tel:2105226769" class="contact-info hidden-xs"><span class="icon">
                                <AppIcon icon="phone-solid"/>
                            </span>210 5226 769</a>
                    <div class="contact-info"><span class="icon">
                                <AppIcon icon="fax-solid"/>
                            </span>210 5202 935
                    </div>
                    <a href="mailto:info@hva.gr" class="contact-info"><span class="icon">
                                <AppIcon icon="envelope-solid"/>
                            </span>info@hva.gr</a>
                </div>
            </div>
        </div>
        <div class="shop-page">
            <Route match="/">
                <Route match="">
                    <Dashboard/>
                </Route>
                <Route match="product" pathIdIndex="1" let:router>
                    <Product productId="{ router.id }"/>
                </Route>
                <Route match="checkout">
                    <Checkout/>
                </Route>
                <Route match="order" let:router>
                    <OrderDetails hash="{ router.id }"/>
                </Route>
                <Route match="order-completed" let:router>
                    <OrderCompleted hash="{ router.id }"/>
                </Route>
                <Route match="order-failed">
                    <OrderFailed/>
                </Route>
                <Route match="signup">
                    <SignUp/>
                </Route>
                <Route match="verify" let:router>
                    <VerifyAccount hash="{ router.id }"/>
                </Route>
                <Route match="reset-password" let:router>
                    <ResetPassword hash="{ router.id }"/>
                </Route>
                <Route match="my-account">
                    <MyAccount/>
                </Route>
                <Route match="my-orders">
                    <Orders/>
                </Route>
                <Route match="documents">
                    <Documents/>
                </Route>
                <Route match="account-error">
                    <AccountError/>
                </Route>
            </Route>
        </div>
    </main>
    <footer>
        {#if showEcommerceLogos}
            <div class="ecommerce-logos">
                <img src="/assets/images/ecommerce-worldline.png" class="img-fluid" alt="λογότυπο worldline">
                <img src="/assets/images/ecommerce-logos-horiz.png" class="img-fluid" alt="λογότυπα ecommerce">
            </div>
        {/if}
        <div class="content">
            <div class="text-center">
                <a href="https://www.hva.gr/el/content.php?page=terms" target="_blank">Όροι χρήσης</a>
            </div>
        </div>
        <div class="credits text-center">
            &copy; 2023 Πανελλήνιος Κτηνιατρικός Σύλλογος
        </div>
    </footer>
{/if}

{#if $user.showLogin}
    <LoginModal/>
{/if}
<Alert/>
<Notifier/>

<style>
    main {
        width: 100%;
        /*min-height: 100vh;*/
        min-height: calc(100vh - 126px);
        background-color: #fff;
        /*box-shadow: 0 0 14px rgba(0, 0, 0, 0.21);*/
        padding-top: var(--header-height);
    }

    main.ecommerce {
        min-height: calc(100vh - 173px);
    }

    .shop-header {
        font-family: var(--secondary-font);
        color: #fff;
        background: #ffffff;
        background: -moz-linear-gradient(top, #ffffff 0%, #ffffff 74%, #d8d9d9 100%);
        background: -webkit-linear-gradient(top, #ffffff 0%, #ffffff 74%, #d8d9d9 100%);
        background: linear-gradient(to bottom, #ffffff 0%, #ffffff 74%, #d8d9d9 100%);
        padding: 10px;
    }

    .shop-header .shop-header-body {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #3f6ab7;
        background: -moz-linear-gradient(top, #3f6ab7 0%, #24509f 100%);
        background: -webkit-linear-gradient(top, #3f6ab7 0%, #24509f 100%);
        background: linear-gradient(to bottom, #3f6ab7 0%, #24509f 100%);
        padding: 10px;
    }

    .shop-header .shop-header-body .contact-info {
        display: flex;
        align-items: center;
        color: #fff;
    }

    .shop-header .shop-header-body .contact-info .icon {
        display: block;
        padding-right: 10px;
    }

    .shop-page {
        padding: 30px;
    }

    .main-container {
        padding-left: 0;
        padding-right: 0;
    }

    footer {
        /*box-shadow: 0 0 14px rgba(0, 0, 0, 0.21);*/
    }

    footer .ecommerce-logos {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        padding: 10px 0;
    }

    footer .ecommerce-logos img {
        display: block;
        margin: 0 5px;
    }

    footer .content {
        color: #fff;
        border-top: 1px solid #051a3e;
        background-color: #09285f;
        padding: 20px 30px 20px 30px;
    }

    footer .content a {
        color: #fff;
    }

    footer .credits {
        font-size: 14px;
        color: #fff;
        background: #051a3e;
        padding: 20px;
    }

    @media (max-width: 576px) {
        main {
            min-height: calc(100vh - 202px);
            height: 100%;
        }

        .shop-page {
            padding: 30px 0;
        }

        .shop-header {
            padding: 0 0 10px 0;
        }

        .shop-header .shop-header-body {
            /*display: block;*/
        }

        .shop-header .shop-header-body .header-body-left {
            width: 170px;
            /*margin-bottom: 1rem;*/
        }

        .shop-header .shop-header-body .header-body-left img {
            width: 100%;
        }

        .shop-header .shop-header-body .header-body-right {
            font-size: 0.8rem;
        }

        footer .ecommerce-logos {
            display: block;
            padding: 10px 15px;
        }

        footer .ecommerce-logos img {
            margin: 0 auto 10px auto;
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .shop-page {
            padding: 30px 10px;
        }
    }


    @media (min-width: 1000px) and (max-width: 1024px) {
        main {

        }

        main .app-main-content {
            padding: 30px 0 0 0;
        }
    }
</style>